if (!window.woenixCollectionShareLoaded) {
  window.woenixCollectionShareLoaded = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.woenix-mobile-card-share');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    const url = new URL(trigger.dataset.productUrl, window.location.origin).href;
    const title = trigger.dataset.productTitle;
    const dialog = document.createElement('dialog');
    dialog.className = 'woenix-share-dialog';
    dialog.setAttribute('aria-label', trigger.getAttribute('aria-label'));
    const heading = document.createElement('h2');
    heading.textContent = trigger.getAttribute('aria-label');
    const productName = document.createElement('p');
    productName.textContent = title;
    const options = document.createElement('div');
    options.className = 'woenix-share-options';
    const linkField = document.createElement('input');
    linkField.value = url;
    linkField.readOnly = true;
    linkField.setAttribute('aria-label', trigger.dataset.linkLabel);
    const status = document.createElement('p');
    status.className = 'woenix-share-status';
    status.setAttribute('role', 'status');
    const addLink = (label, href) => {
      const link = document.createElement('a');
      link.textContent = label;
      link.href = href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      options.append(link);
    };
    const addButton = (label, action) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.addEventListener('click', action);
      options.append(button);
    };
    addLink('WhatsApp', 'https://wa.me/?text=' + encodeURIComponent(title + '\n' + url));
    addLink('Facebook', 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url));
    if (navigator.share) {
      addButton(trigger.dataset.moreLabel, async () => {
        try { await navigator.share({title, url}); }
        catch (error) { if (error.name !== 'AbortError') { linkField.focus(); linkField.select(); } }
      });
    }
    addButton(trigger.dataset.copyLabel, async () => {
      try {
        await navigator.clipboard.writeText(url);
        status.textContent = trigger.dataset.copiedMessage;
      } catch {
        linkField.focus();
        linkField.select();
      }
    });
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'woenix-share-close';
    close.textContent = trigger.dataset.closeLabel;
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (click) => {
      if (click.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (click.clientX < rect.left || click.clientX > rect.right || click.clientY < rect.top || click.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => { dialog.remove(); if (trigger.isConnected) trigger.focus(); }, {once: true});
    dialog.append(heading, productName, options, linkField, status, close);
    document.body.append(dialog);
    dialog.showModal();
  });
}
